<div class="back-home">
  <a class="back-home__link" routerLink="/">{{block.data.text || 'Back to home page'}}</a>
</div>
